import options from "./options.json";

export const CUSTOMIZABLE_AVATAR_PATHS = options.customizableAvatarIds.map(
    (id) => `/assets/avatars/${id}.webp`,
);

export const SELECTABLE_FLAG_CODES = options.selectableFlagCodes;
